import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import Helmet from "react-helmet"

// Layout
import Layout from "layouts/Default"
import IFrame from "layouts/IFrame";


// Views
import * as Pages from "pages";
// Routes
import {UrlPath} from "utility/routes";
import { useEffect, useRef } from "react";
import useAccountData from "hooks/useAccountData";
import { ProtectedRoute } from "components/Authentication/ProtectedRoute";
import { useAuth } from "react-oidc-context";
import { Seo } from "components/Seo";

declare global {
  interface Window {
    dataLayer: any[];
    toggleDataLayerLogging: (state: boolean) => void;
  }
}

const pushUserIdToGTM = (userId: string) => {

  window.dataLayer.push({
    user_id: userId.toLocaleLowerCase()
  });

  if (document.referrer === 'https://sso.1881.no/')
  window.dataLayer.push({
    user_id: userId.toLocaleLowerCase(),
    event: 'login',
    method: 'sso'
  });
}


const useGTMPageView = (delay: number = 200): void => {
  const location = useLocation();
  const timeoutRef = useRef<number | null>(null);

  useEffect(() => {
    // Clear previous timeout if exists
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    // Schedule new push after delay
    timeoutRef.current = window.setTimeout(() => {
      if (window.dataLayer) {
        window.dataLayer.push({
          event: 'pageview',
          page: location.pathname + location.search,
          page_title: document.title,
        });
      }
    }, delay);

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [location, delay]);
};


function App() {
  
  const {collectCompanies} = useAccountData();
  var navigate = useNavigate();
  var auth = useAuth();

  async function fetchCompanies() {
    await collectCompanies();
  }

  useGTMPageView();


useEffect(() => {
  window.dataLayer = window.dataLayer || [];

  let loggingEnabled = false;

  // Expose toggle function in console
  window.toggleDataLayerLogging = (state) => {
    loggingEnabled = state;
    console.log(`DataLayer logging is now ${state ? "ENABLED" : "DISABLED"}`);
  };

  const originalPush = window.dataLayer.push;

  window.dataLayer.push = function (...args) {
    if (loggingEnabled) {
      console.log("DataLayer push:", ...args);
    }
    return originalPush.apply(window.dataLayer, args);
  };
}, []);



  useEffect(() => {
    if(auth.isAuthenticated) {
      pushUserIdToGTM(auth.user?.profile.customer_ref as string);
      fetchCompanies();
      navigate(UrlPath.MyAccount.Home)
    }
   
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth.isAuthenticated])
  return (
    <>
      <Seo />
      <Routes>
        <Route element={<Layout />}>
          <Route path={UrlPath.Frontpage.Home} element={<Pages.Frontpage />} />
          <Route path={UrlPath.ProductDescriptions} element={<Pages.ProductDescriptions /> }/>
          <Route path="/" element={<ProtectedRoute />}>
            <Route path={UrlPath.MyAccount.Home} element={<Pages.Account.MyAccount />} />
            <Route path={UrlPath.MyAccount.AddCompany} element={<Pages.Account.AddCompany/>} />
            <Route path={UrlPath.Account.Company} element={<Pages.Account.EditCompany />} />
            <Route path={UrlPath.Account.CompanyEdit} element={<Pages.Account.EditCompanyInfoList />} />
            <Route path={UrlPath.Account.CompanyEditElements} element={<Pages.Account.EditCompany />} />
            <Route path={UrlPath.Account.LogDetails} element={<Pages.Account.LoggDetails />} />
            <Route path={UrlPath.Account.Products} element={<Pages.Account.Products />} />
            <Route path={UrlPath.Account.ProductConfigBase} element={<Pages.Account.ProductConfig />}/>
            <Route path={UrlPath.Account.WebShop} element={<Pages.Account.WebshopProductList />} />
            <Route path={UrlPath.Account.WebShopProducts} element={<Pages.Account.WebshopProduct />} />
            <Route path={UrlPath.Account.Statistics} element={<Pages.Account.Statistics />} />
            <Route path={UrlPath.Account.ShoppingCartBase} element={<Pages.Account.CheckoutFormList/>} />
            <Route path={UrlPath.Account.OrderOverview} element={<Pages.Account.OrderOverview/>}/>
          </Route>
          <Route path="*" element={<Pages.Error404 />} /> 
        </Route>
        <Route element={<IFrame />}>
          {/* <Route path={UrlPath.Account.Statistics} element={<Pages.Account.Statistics />} /> */}
          <Route path={UrlPath.Account.InfoSite} element={<Pages.Account.InfoSite />} />
        </Route>
      </Routes>
      </>
  );
}
export default App;
